'use client'

import Select from "@/components/UI/Form/Selects/Select/Select";
import ArmenianFlag from "@/public/icons/flags/armenia.svg"
import RussianFlag from "@/public/icons/flags/russia.svg"
import UsaFlag from "@/public/icons/flags/usa.svg"
import {LanguageSelectStyled} from "@/components/UI/Form/Selects/LanguageSelect/LanguageSelect.styled";
import SelectInput from "@/components/UI/Form/Selects/SelectInput/SelectInput";


const LanguageSelect = ({name, label, selected, suffixIcon, onChange, isFormikField, variant = 'light', size = 'xs', ...props}) => {
    const languagesOptions = [
        {
            value: 'hy',
            label: 'ՀԱՅ',
            icon: <ArmenianFlag style={{width: '100%'}}/>
        },
        {
            value: 'en',
            label: 'EN',
            icon: <UsaFlag style={{width: '100%'}}/>
        },
        {
            value: 'ru',
            label: 'РУ',
            icon: <RussianFlag style={{width: '100%'}}/>
        },
    ]

    const Component = isFormikField ? Select : SelectInput

    return (
        <LanguageSelectStyled>
            <Component
                {...props}
                name={name}
                label={label}
                suffixIcon={suffixIcon}
                options={languagesOptions}
                selected={selected}
                variant={variant}
                onChange={onChange}
                size={size}
            />
        </LanguageSelectStyled>
    );
};

export default LanguageSelect;
